import React from 'react';
import InterviewAssistant from '../../components/InterviewAssistant';

function InterviewPage() {
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <InterviewAssistant />
    </div>
  );
}

export default InterviewPage;
